"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var BaseController_1 = require("../../../shared/controllers/BaseController");
var webAApi_1 = require("../../api/webAApi");
var ListBonusTournamentPrizeTypesAvailCtl = /** @class */ (function (_super) {
    __extends(ListBonusTournamentPrizeTypesAvailCtl, _super);
    function ListBonusTournamentPrizeTypesAvailCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_value = UIUtils_1.UIUtils.IProp2Str(function (o) { o.value; });
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this._errDialog = errDialog;
        return _this;
    }
    ListBonusTournamentPrizeTypesAvailCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
            dataEx: []
        };
    };
    ListBonusTournamentPrizeTypesAvailCtl.prototype.getByIdKeyVal = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    ListBonusTournamentPrizeTypesAvailCtl.prototype.getByIdKeyValEx = function (id) {
        for (var i = 0; i < this.DATA.dataEx.length; i++) {
            if (this.DATA.dataEx[i].key === id) {
                return this.DATA.dataEx[i];
            }
        }
        return null;
    };
    ListBonusTournamentPrizeTypesAvailCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListTournamentPrizeTypesAvailGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.dataEx = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].code,
                    value: resp.list[i].title,
                });
            }
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.dataEx.push({
                    key: resp.list[i].code,
                    value: resp.list[i].title,
                    is_bonus: resp.list[i].is_bonus,
                    is_cash: resp.list[i].is_cash,
                    is_dream: resp.list[i].is_dream,
                    is_points: resp.list[i].is_points
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return ListBonusTournamentPrizeTypesAvailCtl;
}(BaseController_1.BaseController));
exports.ListBonusTournamentPrizeTypesAvailCtl = ListBonusTournamentPrizeTypesAvailCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/controllers/ListBonusTournamentsPrizeTypesAvailCtl.ts
// module id = 2120
// module chunks = 0